const { findByAddress } = require('@hints/utils/data');
const Interpretor = require('./interpretor');

module.exports = new Interpretor([
    {
        id: 'normal',
        conditions: [{ id: 'score', min: 0, max: 14, value: e => findByAddress(e, 'evalEmotional.answerScore') }],
    }, 
    {
        id: 'moderate',
        conditions: [{ id: 'score', min: 15, max: 16, value: e => findByAddress(e, 'evalEmotional.answerScore') }],
    }, 
    {
        id: 'high',
        conditions: [{ id: 'score', min: 17, max: 19, value: e => findByAddress(e, 'evalEmotional.answerScore') }],
    },
    {
        id: 'very-high',
        conditions: [{ id: 'score', min: 20, max: 50, value: e => findByAddress(e, 'evalEmotional.answerScore') }],
    }
]);